import { Box } from "@mui/material";
import { useGetIdentity, useLogout } from "@refinedev/core";
import React, { useEffect, useState } from "react";
import { fetchData } from "../../helper";
import { Header as DefaultHeader } from "../header";
import { ThemedSider as DefaultSider } from "../sider";
import { RefineThemedLayoutProps } from "./types";
type DataType = {
  expiredAt: number;
};
export const ThemedLayout: React.FC<RefineThemedLayoutProps> = ({
  Sider,
  Header,
  Title,
  Footer,
  OffLayoutArea,
  children,
}) => {
  const [isSiderOpen, setIsSiderOpen] = useState<boolean>(true);
  const SiderToRender = Sider ?? DefaultSider;
  const HeaderToRender = Header ?? DefaultHeader;
  const data = useGetIdentity<DataType>().data;
  const { mutate: logout } = useLogout();
  useEffect(() => {
    let count = 1;
    const interval = setInterval(() => {
      if (data) {
        const remainingTime =
          data.expiredAt - Math.round(Date.now() / 1000) - 11;
        if (remainingTime < 0) {
          alert("Your authentication information has expired");
          logout();
        }
      }
      const authToken = window.sessionStorage.getItem("authorization");
      if (count % 10000 === 0 && authToken) {
        fetchData("v2/admin/user/session", authToken).then((res) => {
          if (!res.metadata) {
            alert(
              "Your authentication information has expired or your account has logged in elsewhere."
            );
            setTimeout(() => {
              logout();
            }, 0);
          }
        });
      }
      count++;
    }, 1000);
    return () => {
      clearInterval(interval);
      count = 0;
    };
  }, [data, logout]);
  return (
    <Box display="flex" flexDirection="row">
      <SiderToRender
        Title={Title}
        isSiderOpen={isSiderOpen}
        onToggleSiderClick={(isOpen) => setIsSiderOpen(Boolean(isOpen))}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: "100vh",
        }}
      >
        <HeaderToRender
          isSiderOpen={isSiderOpen}
          onToggleSiderClick={() => setIsSiderOpen((prev) => !prev)}
        />
        <Box
          component="main"
          sx={{
            p: { xs: 1, md: 2, lg: 3 },
            flexGrow: 1,
            bgcolor: (theme) => theme.palette.background.default,
          }}
        >
          {children}
        </Box>
        {Footer && <Footer />}
      </Box>
      {OffLayoutArea && <OffLayoutArea />}
    </Box>
  );
};
